import {gql} from '@apollo/client';

export const MUTATION_CREATE_INDICATOR = gql`
mutation createIndicator($data: IndicatorInput!) {
    createIndicator(data: $data) {
        documentId
    }
}`

export const QUERY_INDICATORS = gql`
    query indicators($filters: IndicatorFiltersInput, $pagination: PaginationArg = {}, $sort: [String] = []) {
        indicators(filters: $filters,pagination: $pagination, sort: $sort) {
            documentId
            identifier
            value
            message
            createdAt
        }
    }`